import Interceptor from "./Interceptor";

/**
 * Clear all caches for a site
 */
export const clearSiteCache = async (siteId) => {
  try {
    const response = await Interceptor.post(`/cache/sites/${siteId}/clear`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Clear specific cache type for a site
 */
export const clearSpecificCache = async (siteId, cacheType) => {
  try {
    const response = await Interceptor.post(
      `/cache/sites/${siteId}/clear/${cacheType}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const CacheService = {
  clearSiteCache,
  clearSpecificCache,
};

export default CacheService;
